import { asString, normalizeStringArray } from "./parse-properties";
import { findH4Body, splitH3Entries } from "./parse-sections";
import type { Decision } from "./types";

function parseTopProps(body: string): Record<string, unknown> {
  const props: Record<string, unknown> = {};
  for (const raw of body.split("\n")) {
    if (/^####\s/.test(raw)) break;
    const m = raw.match(/^\s*-\s+([a-zA-Z_][a-zA-Z0-9_-]*)\s*:\s*(.*)$/);
    if (!m) continue;
    const key = m[1];
    const rawValue = (m[2] ?? "").trim();
    if (key === undefined || rawValue.length === 0) continue;
    if (rawValue.startsWith("[") && rawValue.endsWith("]")) {
      const inner = rawValue.slice(1, -1).trim();
      props[key] =
        inner.length === 0
          ? []
          : inner
              .split(",")
              .map((s) => s.trim().replace(/^"|"$/g, "").replace(/^'|'$/g, ""))
              .filter((s) => s.length > 0);
      continue;
    }
    let scalar: unknown = rawValue;
    if (
      (rawValue.startsWith('"') && rawValue.endsWith('"')) ||
      (rawValue.startsWith("'") && rawValue.endsWith("'"))
    ) {
      scalar = rawValue.slice(1, -1);
    }
    props[key] = scalar;
  }
  return props;
}

export function parseDecisions(sectionBody: string): Decision[] {
  const entries = splitH3Entries(sectionBody);
  return entries.map((entry) => {
    const id = entry.title.trim();
    const top = parseTopProps(entry.body);
    return {
      id,
      label: asString(top.label) ?? id,
      status: asString(top.status) ?? "proposed",
      why: asString(top.why),
      date: asString(top.date),
      applies_to: normalizeStringArray(top.applies_to),
      tags: normalizeStringArray(top.tags),
      context: findH4Body(entry.body, "Context")?.trim(),
      optionsConsidered: findH4Body(entry.body, "Options Considered")?.trim(),
      decision: findH4Body(entry.body, "Decision")?.trim(),
      consequences: findH4Body(entry.body, "Consequences")?.trim(),
    };
  });
}
